// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatRoomBottomBar_main__2zIFQ"};